<template>
    <section class="section-categorias-component py-2">
        <div class="row mx-0 position-relative">
            <!-- Arrows -->
            <div v-if="productosPrimeraLinea.lenght <= 7 || productosSegundaLinea.lenght <= 7" class="d-middle-center position-absolute cr-pointer bg-white rounded-circle shadow z-1" style="width:32px;height:32px;left:5px;top:36%;" @click="leftScroll">
                <i class="icon-left-open text-general f-20" />
            </div>
            <div v-if="productosPrimeraLinea.lenght <= 7 || productosSegundaLinea.lenght <= 7" class="d-middle-center position-absolute cr-pointer bg-white rounded-circle shadow z-1" style="width:32px;height:32px;right:50px;top:36%;" @click="rightScroll">
                <i class="icon-right-open text-general f-20" />
            </div>
            <!-- Arrows -->
            <div id="container" class="col px-0 overflow-auto custom-scroll">
                <div :class="`${dosLineas ? 'mb-4' : ''}`" style="display:inline-flex;">
                    <div v-for="(producto,key) in productosPrimeraLinea" :key="key" @click="guardarClick(producto.id_elemento)">
                        <invitado-producto v-if="isInvitado" :producto="producto" class="mx-xl-4 mx-lg-3 mx-md-3 mx-sm-2 mx-2" />
                        <card-producto v-else :producto="producto" :promocion="producto.data_promocion" class="mx-xl-4 mx-lg-3 mx-md-3 mx-sm-2 mx-2" />
                    </div>
                </div>
                <template v-if="dosLineas">
                    <div style="display:inline-flex;">
                        <div v-for="(producto,key) in productosSegundaLinea" :key="key" @click="guardarClick(producto.id_elemento)">
                            <invitado-producto v-if="isInvitado" :producto="producto" class="mx-xl-4 mx-lg-3 mx-md-3 mx-sm-2 mx-2" />
                            <card-producto v-else :producto="producto" :promocion="producto.data_promocion" class="mx-xl-4 mx-lg-3 mx-md-3 mx-sm-2 mx-2" />
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        data:{
            type:Object,
            default:() => {}
        },
    },
    data(){
        return {
            activeComponent: false,
        }
    },
    computed:{
        ...mapGetters({
            isInvitado:'home/isInvitado',
        }),
        productos(){
            return this.data.elementos.productos
        },
        dosLineas(){
            if(this.data.tipo == 41){
                return false
            }
            return true
        },
        productosPrimeraLinea(){
            let productos = []
            if(this.dosLineas){
                this.productos.map((e, index) => {
                    let posicion = index + 1;
                    if((posicion % 2) != 0){
                        productos = [...productos, e];
                    } 
                });
            } else {
                return this.productos
            }
            return productos
        },
        productosSegundaLinea(){
            let productos = []
            if(this.dosLineas){
                this.productos.map((e, index) => {
                    let posicion = index + 1;
                    if((posicion % 2) == 0){
                        productos = [...productos, e];
                    }
                });
            } else {
                return []
            }
            return productos
        }
    },
    methods: {
        async guardarClick(idElemento){
            this.$store.dispatch('home/guardarClick',idElemento)
        },
        leftScroll(){
            let container = document.getElementById('container');
            this.sideScroll(container,'left',25,100,25);
        },
        rightScroll(){
            let container = document.getElementById('container');
            this.sideScroll(container,'right',25,100,25);
        },
        sideScroll(element,direction,speed,distance,step){
            let scrollAmount = 0;
            var slideTimer = setInterval(function(){
                if(direction == 'left'){
                    element.scrollLeft -= step;
                } else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if(scrollAmount >= distance){
                    window.clearInterval(slideTimer);
                }
            }, speed);
        }
    }
}
</script>